class BlogGrid extends HTMLElement {
  constructor() {
    super();
  }

  get nextUrl() {
    return this.dataset.nextUrl;
  }

  connectedCallback() {
    this.articlesContainer = this.querySelector("[data-blog-articles-container]");
    this.loadMoreButton = this.querySelector("#blog-grid__load-more-button");
    this.handleClick = this.handleClick.bind(this);

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.loadMoreButton) {
      this.loadMoreButton.removeEventListener('click', this.handleClick);
    }
  }

  handleClick(event) {
    fetch(this.nextUrl)
      .then(response => response.text())
      .then((html) => {

        // get the next URL
        const parser = new DOMParser();
        const nextPage = parser.parseFromString(html, "text/html");
        const nextUrl = nextPage.querySelector("blog-grid").dataset.nextUrl;

        // update data-next-url of <product-grid>
        this.dataset.nextUrl = nextUrl;

        // remove button
        if (!nextUrl) {
          event.target.remove();
        }

        // append products in next URL to the <product-grid>
        const cards = nextPage.querySelectorAll(".blog-grid__card");
        cards.forEach((card) => {
          this.articlesContainer.append(card);
        })

      })
      .catch((error) => {
        console.error('Error: ', error);
      })
  }
}

customElements.define('blog-grid', BlogGrid);
